<template>
  <div>
    <v-alert
      v-if="token && !agreed && !hide"
      prominent
      border="left"
      color="#662d91"
      transition="scale-transition"
    >
      <v-row align="center">
        <v-col class="grow py-0 white--text"
          >We have updated our
          <a style="color: yellow" @click="openPrivacyPolicy"
            ><u>Privacy Policy</u></a
          >
          and
          <a style="color: yellow" @click="openTermsAndConditions"
            ><u>Terms and Conditions</u></a
          >. Please review the changes before continuing.</v-col
        >
        <v-col class="shrink py-0">
          <v-btn depressed color="white" @click="agree"
            ><p>I Have read them!</p></v-btn
          >
        </v-col>
      </v-row>
    </v-alert>
    <TermsAndConditions ref="termsAndConditions"></TermsAndConditions>
    <PrivacyPolicy ref="privacyPolicy"></PrivacyPolicy>
  </div>
</template>

<script>
import TermsAndConditions from '../usage/TermsAndConditions.vue'
import PrivacyPolicy from '../usage/PrivacyPolicy.vue'

export default {
  components: {
    TermsAndConditions,
    PrivacyPolicy
  },
  props: ['token', 'agreed'],
  data() {
    return {
      hide: false
    }
  },
  methods: {
    openTermsAndConditions() {
      this.$refs.termsAndConditions.open()
    },
    openPrivacyPolicy() {
      this.$refs.privacyPolicy.open()
    },
    async agree() {
      this.hide = true
      await this.$store.dispatch('auth/agreePrivacyTC')
    }
  }
}
</script>
